<script>
import { mapActions, mapState } from 'vuex'
import Switch from '../Utils/Switch'

export default {
  name: 'Access',
  components: { Switch },
  props: [
    'desiresAccess',
  ],
  computed: {
    ...mapState([
      'location'
    ]),
    ...mapState('access', [
      'options',
    ]),
  },
  data() {
    return {
      visible: true,
      zIndex: 500,
    }
  },
  watch: {
    location() {
      this.visible = false
      this.zIndex = -1
      setTimeout(() => {
        this.visible = true
        setTimeout(() => {
          this.zIndex = 500
        }, 800)
      }, 700)
    },
    desiresAccess() {
      if (this.desiresAccess) {
        this.$el.focus()
      } else {
        this.$el.blur()
      }
    }
  },
  methods: {
    ...mapActions('access', [
      'setOption'
    ]),
    blur() {
      console.log('blur')
      this.$el.blur()
    }
  }
}
</script>

<template>
  <div
    id="access"
    :class="['ui', { visible }]"
    :style="{ zIndex }"
    tabindex="0"
    aria-label="The application's accessibility options"
  >
    <div
      class="header"
    >
      <img
        @click.stop="blur()"
        src="../../assets/icons/accessibility-black.svg"
      />
    </div>
    <Switch
      v-for="(option, key) in options"
      :key="key"
      :id="key"
      :label="option.label"
      :value="option.value"
      :icons="option.icons"
      @toggle="setOption({ key, value: $event })"
    />
  </div>
</template>


<style scoped>
#access {
  position: absolute;
  top: 2em;
  left: 2em;
  min-width: 0;
  max-width: 0;
  max-height: 0;
  min-height: 0;
  opacity: 0;
  pointer-events: none;
  padding: 4em;
  transition:
    filter var(--veryslow) ease,
    transform var(--slow) ease,
    opacity var(--fast) ease,
    padding var(--slow) ease,
    top var(--slow) ease,
    left var(--slow) ease,
    max-height var(--slow) ease,
    min-height var(--slow) ease,
    min-width var(--slow) ease,
    max-width var(--slow) ease
  ;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#access .header {
  height: 3em;
  width: 3em;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 0.5em;
  transition:
    padding var(--slow) ease,
  ;
}

#access .header img {
  height: 3em;
  width: 3em;
}

#access .switch {
  opacity: 0;
  min-width: 14em;
  text-align: center;
  transition:
    opacity var(--slow) ease,
  ;
}

/* nav:hover #access { */
#access.visible {
  pointer-events: all;
  padding: 2em;
  transform: scale(1.1);
  top: -5em;
  left: 0;
  opacity: 1;
}
#access.visible * {
  opacity: 1;
}
/* nav:hover #access:hover { */
#access.visible:hover,
#access.visible:focus,
#access.visible:focus-within {
  top: -14em;
  left: -2em;
  min-width: 12em;
  min-height: 26em;
  max-height: 26em;
  max-width: 14em;
}
#access.visible:hover .header,
#access.visible:focus .header,
#access.visible:focus-within .header {
  padding-bottom: 0;
}
#access.visible:hover .switch,
#access.visible:focus .switch,
#access.visible:focus-within .switch {
  /* transform: scale(1); */
  opacity: 1;
}

.routing #access {
  pointer-events: none;
}

.isMobile #access  {
  padding: 1em;
  top: 3em;
  transform: scale(1);
}
.isMobile #access.visible {
  /* top: -2.5em; */
  top: 0em;
  left: 2.5em;
}
.isMobile #access .header {
  padding-bottom: 0.1em;
}
.isMobile #access .header,
.isMobile #access .header img {
  height: 2em;
  width: 2em;
}

.isMobile #access.visible:hover,
.isMobile #access.visible:focus,
.isMobile #access.visible:focus-within {
  top: -12em;
  left: -4em;
  min-width: 12em;
  min-height: 26em;
  max-height: 26em;
  max-width: 14em;
}

#app.route-meditation.isMobile #access.visible:hover,
#app.route-meditation.isMobile #access.visible:focus,
#app.route-meditation.isMobile #access.visible:focus-within {
  min-height: 16em;
  max-height: 16em;
}

@media screen and (max-width : 1100px)  and (min-width : 750px) {
/* @media screen and (max-width : 1100px) { */
  #access  {
    padding: 2em !important;
    top: 3em;
    transform: scale(1) !important;
  }
  #access.visible {
    top: 0px;
    /* top: 0em; */
    left: 100px;
  }
  #access .header {
    padding-bottom: 0.1em;
  }
  #access .header,
  #access .header img {
    height: 2em;
    width: 2em;
  }
  #access.visible:hover,
  #access.visible:focus,
  #access.visible:focus-within {
    top: -20em;
    left: -4em;
    min-width: 12em;
    min-height: 26em;
    max-height: 26em;
    max-width: 14em;
  }

  #app.route-meditation #access.visible:hover,
  #app.route-meditation #access.visible:focus,
  #app.route-meditation #access.visible:focus-within {
    min-height: 16em;
    max-height: 16em;
  }

  nav:hover #access {
    left: 8em;
    top: -2em;
  }

}

</style>
